//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      localSearchString: '',
      filters: {
        searchString: undefined,
        createdAtFrom: undefined,
        createdAtTo: undefined,
        getCurrencyId: undefined,
        giveCurrencyId: undefined,
        statuses: [],
        amountFrom: undefined,
        amountTo: undefined,
        limitFrom: undefined,
        limitTo: undefined,
        tradeType: undefined,
      },
      showIe: false,
      constant,
    };
  },

  computed: {
    ...mapState('p2pDeals', ['filterLists']),
    ...mapState('p2p', ['p2pCurrencies']),

    cryptoCurrencies() {
      const { p2pCurrencies } = this;
      return p2pCurrencies.filter((e) => e.type === constant.p2p.CURRENCY_TYPE.CRYPTO);
    },

    fiatCurrencies() {
      const { p2pCurrencies } = this;
      return p2pCurrencies.filter((e) => e.type === constant.p2p.CURRENCY_TYPE.FIAT);
    },

    fiatAndCryptoCurrencies() {
      const { fiatCurrencies, cryptoCurrencies } = this;
      return [...fiatCurrencies, ...cryptoCurrencies];
    },

    crossTradeItems() {
      return [
        {
          id: true,
          caption: 'Cross trades only',
        },
        {
          id: false,
          caption: 'Direct trades only',
        },
      ];
    },
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
    showIe(boolean) {
      this.filters.tradeType = boolean ? 'Transfer' : undefined;
    },
  },

  created() {
    const {
      DealsSearchString,
    } = this.$route.query;

    const status = this.$route.query.Statuses;

    if (status) {
      this.filters = {
        ...this.filters,
        Statuses: status,
      };
      this.$router.replace({ query: {} });
    }

    if (DealsSearchString) {
      this.filters = {
        ...this.filters,
        SearchString: DealsSearchString || '',
      };
      this.setFilters(this.filters);
      this.$emit('update');
      this.$router.replace({ query: {} });
      this.$refs.p2pDealsBlock.scrollIntoView({
        behavior: 'smooth',
      });
    } else {
      this.setFilters({});
    }
  },

  methods: {
    ...mapActions('p2pDeals', ['setFilters']),

    handleSearchBlur() {
      this.filters.searchString = this.localSearchString;
    },
  },
};
